/**
 * @param dateString format: yyyy-mm-dd
 * @returns Date object corresponding to given string
 */
export const stringToDate = (dateString: string): Date => {
  const [y, m, d] = dateString.split('-');
  return new Date(parseInt(y), parseInt(m) - 1, parseInt(d));
};
